import { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { faqs } from '../data/faqs';
import type { FAQ } from '../types';

function FAQItem({ faq, isOpen, onToggle }: { faq: FAQ; isOpen: boolean; onToggle: () => void }) {
  return (
    <div className="group bg-slate-800/40 backdrop-blur-sm rounded-xl border border-white/10 transition-all duration-300 hover:border-blue-500/30 hover:bg-slate-800/60">
      <button
        onClick={onToggle}
        className="w-full text-left px-6 py-4 flex items-center justify-between gap-4"
      >
        <span className="text-lg font-medium text-slate-50">{faq.question}</span>
        {isOpen ? (
          <Minus className="w-5 h-5 text-blue-400 shrink-0" />
        ) : (
          <Plus className="w-5 h-5 text-blue-400 shrink-0" />
        )}
      </button>
      {isOpen && (
        <div className="px-6 pb-4">
          <p className="text-slate-300">{faq.answer}</p>
        </div>
      )}
    </div>
  );
}

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="max-w-6xl mx-auto px-4 py-16 sm:py-24">
      <h2 className="text-3xl sm:text-4xl font-bold text-center text-slate-50 mb-6">
        Frequently Asked Questions
        <div className="mt-2 mx-auto w-20 h-1 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full" />
      </h2>
      <p className="text-center text-slate-300 mb-16 max-w-2xl mx-auto">
        Get answers to common questions about Pipedrive and HubSpot CRM solutions
      </p>
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <FAQItem
            key={index}
            faq={faq}
            isOpen={openIndex === index}
            onToggle={() => setOpenIndex(openIndex === index ? null : index)}
          />
        ))}
      </div>
    </section>
  );
}